import React from 'react';
import { useSelector } from 'react-redux';
import { markenStandortSelector,  } from '../../../modules/selectors/standort/markenStandort';
import Image from '../../components/Image/Image';
import ApsLocationTiles from '../../components/apsLocationTiles/ApsLocationTiles';



export default function APSHome() {
    const markenStandort = useSelector(markenStandortSelector);

    return (
        <>
            <Image src="https://techno-images.s3.eu-central-1.amazonaws.com/icons/aps_landingpage_icon.png" alt="APS Landingpage Logo" resizeHeight={50} />
            
            <h1 className='uk-text-normal'><strong>Herzlich willkommen bei AutoteilePlusService</strong></h1>
            <p className='uk-text-center'>
                Hier finden Sie den passenden Onlineshop für Ihre Automarke.<br /> 
                Es erwartet Sie ein großes Sortiment aus Originalteilen und markenspezifischem Zubehör – zur Lieferung und Abholung.<br /> 
                Nach Ihrer Auswahl des Shops werden Sie direkt in den Autohaus-Onlineshop weitergeleitet.<br/>
                Wir wünschen Ihnen viel Spaß beim Shoppen! 
            </p>
            <ApsLocationTiles />

        </>
    );
}
